// lib/continuum/simulation/methodology.js
// ═══════════════════════════════════════════════════════════
// LEGACY SHIM — re-exports the declarative dynamics-registry in
// the older array shape so existing front-end code keeps working
// while we migrate.
//
// New code should import from `dynamics-registry.js` directly.
// This file is kept for backward compatibility and will be
// removed once all consumers have migrated.
//
// What changed:
//   - Old: DYNAMICS = [{ key, eco_sources, human_sources, ... }]
//   - New: DYNAMICS_REGISTRY = [{ id, domains: { eco, human }, ... }]
//
// This shim aliases the new fields to the old names so legacy
// imports of DYNAMICS continue to work unchanged.
// ═══════════════════════════════════════════════════════════

import {
  DYNAMICS_REGISTRY,
  DYNAMICS_BY_ID,
  snapshotRegistry,
} from './dynamics-registry.js';

// Legacy DYNAMICS array — same shape as before, with id aliased to
// key and domains.eco.sources flattened to eco_sources.
export const DYNAMICS = DYNAMICS_REGISTRY.map(d => ({
  ...d,
  key:           d.id,
  eco_sources:   d.domains?.eco?.sources   || [],
  human_sources: d.domains?.human?.sources || [],
  extractor_id:  d.extractor_id || `${d.id}_v${d.version}`,
  config:        d.metric || {},
}));

export const DYNAMICS_BY_KEY = Object.fromEntries(
  DYNAMICS.map(d => [d.key, d])
);

// Re-export the BY_ID lookup too — both names are common
export { DYNAMICS_BY_ID };

// Legacy snapshot function — same signature, calls into registry
export function snapshotMethodology() {
  return snapshotRegistry();
}
